import styled from 'styled-components';

export const Tree = styled.div`
  background: #fff;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  color: #303030;
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #696969;
  padding: 10px 14px 6px;
  display: flex;

  span {
    margin-left: auto;
    text-transform: none;
    letter-spacing: 0;
    color: #999;
  }
`;

export const Node = styled.div<{ $leaf?: boolean; $clickable?: boolean }>`
  display: grid;
  grid-template-columns: 16px 90px 1fr auto;
  gap: 8px;
  align-items: center;
  padding: 8px 14px 8px ${({ $leaf }) => ($leaf ? '30px' : '14px')};
  border-top: 1px solid #f4f4f4;
  font-size: 12.5px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  b {
    font-variant-numeric: tabular-nums;
  }
`;

export const NodeRight = styled.span`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const Caret = styled.span`
  color: #999;
  display: inline-flex;
`;


export const AdoptButton = styled.button`
  height: 26px;
  font: 600 11px 'Inter', sans-serif;
  padding: 0 10px;
  border-radius: 100px;
  border: 1px solid #0090d3;
  background: #fff;
  color: #0090d3;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Hint = styled.div`
  font-size: 12px;
  color: #999;
  padding: 10px 14px;
`;
